import { Link } from 'react-router-dom'
import { HiOutlineLockClosed } from 'react-icons/hi2'
import { Button } from '@/components/ui/Button'

export function Forbidden() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-danger-50 text-3xl text-danger">
        <HiOutlineLockClosed />
      </div>
      <h1 className="mt-5 text-2xl font-bold">Access restricted</h1>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground">
        Your role doesn't have permission to view this section. Contact the office administrator if
        you believe this is a mistake.
      </p>
      <Link to="/dashboard" className="mt-6">
        <Button variant="primary">Back to Dashboard</Button>
      </Link>
    </div>
  )
}

export function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="text-6xl font-black text-primary-100">404</p>
      <h1 className="mt-2 text-2xl font-bold">Page not found</h1>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/dashboard" className="mt-6">
        <Button variant="primary">Back to Dashboard</Button>
      </Link>
    </div>
  )
}
